export var SOCIAL_AUTHENTICATE_TYPE = 'social/authenticate/status_changed';
export var SOCIAL_CREATE_TYPE = 'social/create/status_changed';
export var SOCIAL_MERGE_TYPE = 'social/merge/status_changed';